import React, { FC } from 'react';
import { BpDesignSystem } from '../../types';
import MuiCardHeader, { CardHeaderProps as MuiCardHeaderProps } from '@mui/material/CardHeader';

export type CardHeaderProps = BpDesignSystem.PropsWithChildren<MuiCardHeaderProps & {}>;

export const CardHeader: FC<CardHeaderProps> = ({ dataTest, ...props }) => (
  <MuiCardHeader data-test={dataTest} {...props} />
);
